import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappApiDocumentation = () => (
  <>
    <Helmet>
      <title>WhatsApp API Documentation &amp; Developer Guide | HAWKTRION</title>
      <meta name="description" content="Find HAWKTRION WhatsApp API endpoints, authentication guidance, webhook details, and integration steps. Open the live developer documentation." />
      <meta name="keywords" content="WhatsApp API documentation, WhatsApp developer guide, HAWKTRION API docs" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api-documentation/" />
      <meta property="og:title" content="WhatsApp API Documentation &amp; Developer Guide | HAWKTRION" />
      <meta property="og:description" content="Find HAWKTRION WhatsApp API endpoints, authentication guidance, webhook details, and integration steps. Open the live developer documentation." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api-documentation/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API Documentation &amp; Developer Guide | HAWKTRION" />
      <meta name="twitter:description" content="Find HAWKTRION WhatsApp API endpoints, authentication guidance, webhook details, and integration steps. Open the live developer documentation." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp API Documentation and Developer Guide" hideCta>
      <RemainingLandingContent pageKey="documentation" />
    </SeoLandingPage>
  </>
);

export default WhatsappApiDocumentation;